import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { Collapse, List, ListItemButton, ListItemText } from '@mui/material'

import ExpandMoreIcon from '../../assets/icons/expand-more-icon.svg'

const DrawerMenuButton = ({
  icon,
  buttonText,
  nestedMenu,
  openSubmenu,
  nestedMenuItems,
  active,
  sx,
  handleOpenSubmenu,
  handleTriggerMenuAction
}: {
  icon: ReactNode
  buttonText: string
  nestedMenu?: boolean
  openSubmenu?: boolean
  nestedMenuItems?: Array<object>
  active?: boolean
  sx?: object
  handleOpenSubmenu?: (openSubmenuState: boolean) => void
  handleTriggerMenuAction?: () => void
}) => {
  const navigate = useNavigate()

  return (
    <>
      <div
        style={sx}
        className={active && !nestedMenu ? 'drawer-menu-button-active' : 'drawer-menu-button'}
        onClick={() => {
          if (handleOpenSubmenu) handleOpenSubmenu(!openSubmenu)
          else if (!nestedMenu && handleTriggerMenuAction) handleTriggerMenuAction()
        }}
      >
        <div className="drawer-menu-label">
          <div className="drawer-menu-icon">{icon}</div>
          <div className="drawer-menu-button-text">{buttonText}</div>
        </div>
        {nestedMenu && (
          <div className={openSubmenu ? 'drawer-submenu-expanded' : 'drawer-submenu-to-expand'}>
            <img
              src={ExpandMoreIcon}
              alt="expand-more-icon"
            />
          </div>
        )}
      </div>
      {nestedMenu && (
        <Collapse
          in={openSubmenu}
          timeout="auto"
          unmountOnExit
        >
          <List
            component="div"
            disablePadding
          >
            {nestedMenuItems?.map((item: any, index: number) => (
              <span key={index}>
                <ListItemButton
                  component="div"
                  selected={item.selected}
                  onClick={() => navigate(item.link)}
                  sx={{ pl: 4, borderBottom: '1px dashed #2ED3B7' }}
                >
                  <ListItemText
                    className="drawer-submenu-button-text"
                    primary={item.name}
                  />
                </ListItemButton>
              </span>
            ))}
          </List>
        </Collapse>
      )}
    </>
  )
}

export default DrawerMenuButton
